import React from "react";
import { includes, map, pickBy } from "lodash-es";
import { Input, DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from "reactstrap";
import { uniqid } from "../utils";

const PLACEMENT_OFFSET = 40;
const INITIAL_HEIGHT = 15;
const INITIAL_WIDTH = 150;

const newField = (label, type, isCustom, field = "", page = 0) => ({
  id: uniqid(),
  label,
  type,
  field,
  position: {
    page,
    at: {
      x: PLACEMENT_OFFSET,
      y: PLACEMENT_OFFSET,
    },
  },
  options: {
    height: INITIAL_HEIGHT,
    width: INITIAL_WIDTH,
  },
  required: !isCustom, // Custom fields default to not-required
});

const buildAddButton = (label, type, isCustom, key, page, onClick) => {
  return (
    <DropdownItem key={key} onClick={() => onClick(newField(label, type, isCustom, key, page))}>
      <code>{label}</code>
    </DropdownItem>
  );
};

const typeMap = {
  string: "text",
  boolean: "checkmark",
  date: "date",
};

export const dataTypeToFieldType = (dataType) => typeMap[dataType] || "text";

export class AddFieldDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);

    this.state = {
      filter: "",
      dropdownOpen: false,
    };
  }

  toggle() {
    this.setState((prevState) => {
      // Get new state
      const dropdownOpen = !prevState.dropdownOpen;

      // Clear the filter on close
      const filter = dropdownOpen === false ? "" : prevState.filter;

      return {
        dropdownOpen,
        filter,
      };
    });
  }

  onFilterChange(e) {
    e.persist();
    this.setState({ filter: e.target.value });
  }

  render() {
    const { currentPage, onAddField, defaultFields, customFields } = this.props;
    const { dropdownOpen, filter } = this.state;

    // Filter Data
    const filteredDefaultFields = pickBy(defaultFields, (f) => includes(f.label.toLowerCase(), filter.toLowerCase()));

    const filteredCustomFields = pickBy(customFields, (f) => includes(f.label.toLowerCase(), filter.toLowerCase()));

    // Setup Buttons
    const defaultFieldButtons = map(filteredDefaultFields, (f, key) => {
      return buildAddButton(f.label, dataTypeToFieldType(f.type), false, key, currentPage, onAddField);
    });

    const customFieldButtons = map(filteredCustomFields, (f, key) => {
      return buildAddButton(f.label, dataTypeToFieldType(f.type), true, `custom:${key}`, currentPage, onAddField);
    });

    // Render Component

    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggle} className="w-100">
        <DropdownToggle size="sm" className="btn-block" caret>
          Add Field
        </DropdownToggle>
        <DropdownMenu style={{ height: 300, overflowY: "auto", width: "100%" }} data-testid="fde-add-field-menu">
          <div className="mx-2">
            <Input autoFocus bsSize="sm" placeholder="Filter..." onChange={this.onFilterChange} />
          </div>
          <DropdownItem divider />

          <DropdownItem header>Generic Fields</DropdownItem>
          <DropdownItem onClick={() => onAddField(newField("New Text Field", "text", false))}>
            <code>Text</code>
          </DropdownItem>
          <DropdownItem onClick={() => onAddField(newField("New Checkbox", "checkmark", false))}>
            <code>Checkbox</code>
          </DropdownItem>

          <DropdownItem header>Default Fields</DropdownItem>
          {defaultFieldButtons ? defaultFieldButtons : <DropdownItem disabled>No Fields</DropdownItem>}

          <DropdownItem divider />
          <DropdownItem header>Custom Fields</DropdownItem>
          {customFieldButtons ? customFieldButtons : <DropdownItem disabled>No Custom Fields</DropdownItem>}
        </DropdownMenu>
      </Dropdown>
    );
  }
}
